import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence, useInView } from 'framer-motion';
import { useRef } from 'react';
import '../styles/galary.css';
import {
  FaChevronRight, FaChevronLeft, FaTimes, FaSearchPlus, FaImages, FaExpand
} from 'react-icons/fa';

const allImages = [
  '/Assets/imgkmk2.jpg',  '/Assets/imgkmk1.jpg',  '/Assets/imgkmk3.jpg',
  '/Assets/imgkmk4.jpg',  '/Assets/imgkmk5.jpg',  '/Assets/kmkimg1.jpg',
  '/Assets/kmkimg2.jpg',  '/Assets/kmkimg3.jpg',  '/Assets/kmkimg4.jpg',
  '/Assets/kmkimg5.jpg',  '/Assets/kmkimg6.jpg',  '/Assets/kmkimg7.jpg',
  '/Assets/kmkimg8.jpg',  '/Assets/kmkimg9.jpg',  '/Assets/kmkimg10.jpg',
  '/Assets/kmkimg11.jpg', '/Assets/kmkimg12.jpg', '/Assets/kmkimg13.jpg',
  '/Assets/kmkimg14.jpg', '/Assets/kmkimg15.jpg', '/Assets/kmkimg16.jpg',
  '/Assets/kmkimg17.jpg', '/Assets/kmkimg18.jpg', '/Assets/kmkimg19.jpg',
  '/Assets/kmkimg20.jpg', '/Assets/kmkimg21.jpg', '/Assets/kmkimg22.jpg',
  '/Assets/kmkimg23.jpg', '/Assets/kmkimg24.jpg', '/Assets/kmkimg25.jpg',
  '/Assets/kmkimg26.jpg', '/Assets/kmkimg27.jpg', '/Assets/kmkimg28.jpg',
  '/Assets/kmkimg29.jpg', '/Assets/kmkimg30.jpg', '/Assets/kmkimg31.jpg',
  '/Assets/kmkimg32.jpg', '/Assets/kmkimg33.jpg', '/Assets/kmkimg34.jpg',
  '/Assets/kmkimg35.jpg', '/Assets/kmkimg36.jpg', '/Assets/kmkimg37.jpg',
  '/Assets/imgkmk6.jpg',  '/Assets/imgkmk7.jpg',  '/Assets/imgkmk8.jpg',
  '/Assets/imgkmk9.jpg',  '/Assets/imgkmk10.jpg', '/Assets/imgkmk11.jpg',
  '/Assets/imgkmk12.jpg', '/Assets/imgkmk13.jpg', '/Assets/imgkmk14.jpg',
  '/Assets/imgkmk15.jpg', '/Assets/imgkmk16.jpg', '/Assets/imgkmk17.jpg',
  '/Assets/imgkmk18.jpg', '/Assets/imgkmk19.jpg',
];

const itAssets = [
  '/Assets/kmkimg15.jpg', '/Assets/kmkimg16.jpg', '/Assets/kmkimg17.jpg',
  '/Assets/kmkimg18.jpg', '/Assets/kmkimg19.jpg', '/Assets/kmkimg20.jpg',
  '/Assets/kmkimg21.jpg', '/Assets/kmkimg22.jpg', '/Assets/kmkimg23.jpg',
  '/Assets/kmkimg24.jpg', '/Assets/kmkimg25.jpg', '/Assets/kmkimg26.jpg',
  '/Assets/kmkimg27.jpg', '/Assets/kmkimg28.jpg', '/Assets/kmkimg29.jpg',
  '/Assets/kmkimg30.jpg', '/Assets/kmkimg31.jpg', '/Assets/kmkimg32.jpg',
  '/Assets/kmkimg33.jpg', '/Assets/kmkimg34.jpg', '/Assets/kmkimg35.jpg',
  '/Assets/kmkimg36.jpg', '/Assets/kmkimg37.jpg',
];

const metalScrap = [
  '/Assets/imgkmk6.jpg',  '/Assets/imgkmk7.jpg',  '/Assets/imgkmk8.jpg',
  '/Assets/imgkmk9.jpg',  '/Assets/imgkmk10.jpg', '/Assets/imgkmk11.jpg',
  '/Assets/imgkmk12.jpg', '/Assets/imgkmk13.jpg', '/Assets/imgkmk14.jpg',
  '/Assets/imgkmk15.jpg', '/Assets/imgkmk16.jpg', '/Assets/imgkmk17.jpg',
  '/Assets/imgkmk18.jpg', '/Assets/imgkmk19.jpg', '/Assets/kmkimg1.jpg',
];

const filters = [
  { label:'All',               icon:'🌿', images:allImages  },
  { label:'IT Assets & E‑Waste',icon:'💻', images:itAssets  },
  { label:'Metal Scrap',        icon:'⚙️', images:metalScrap },
];

const stagger = { hidden:{}, show:{ transition:{ staggerChildren:0.06, delayChildren:0.05 } } };
const fadeUp  = { hidden:{opacity:0,y:30}, show:{opacity:1,y:0,transition:{duration:0.5,ease:'easeOut'}} };

function GridSection({ images, onOpen }) {
  const ref    = useRef(null);
  const inView = useInView(ref, { once:true, margin:'-60px' });
  return (
    <motion.div
      className="gallery-grid"
      ref={ref}
      variants={stagger}
      initial="hidden"
      animate={inView ? 'show' : 'hidden'}
    >
      {images.map((src, i) => (
        <motion.button
          type="button"
          className={`gallery-item${i===0?' gallery-item--featured':''}`}
          key={`${src}-${i}`}
          variants={fadeUp}
          onClick={() => onOpen(i)}
          aria-label={`View image ${i+1} of ${images.length}`}
          whileHover={{ scale:1.02, transition:{duration:0.2} }}
          whileTap={{ scale:0.98 }}
        >
          <img src={src} alt={`KMK Industries gallery ${i+1}`} className="gallery-img" loading="lazy" />
          <div className="gallery-item-overlay">
            <span className="gallery-item-icon"><FaSearchPlus /></span>
            <span className="gallery-item-num">{i+1} / {images.length}</span>
          </div>
        </motion.button>
      ))}
    </motion.div>
  );
}

const Galary = () => {
  const [activeTab, setActiveTab]   = useState(0);
  const [lightbox,  setLightbox]    = useState(-1);
  const [isChanging, setIsChanging] = useState(false);

  const images = filters[activeTab].images;

  const close = useCallback(() => setLightbox(-1), []);
  const step  = useCallback(
    (dir) => setLightbox(i => i<0 ? i : (i+dir+images.length)%images.length),
    [images.length]
  );

  const switchTab = (i) => {
    if (i === activeTab) return;
    setIsChanging(true);
    setTimeout(() => { setActiveTab(i); setLightbox(-1); setIsChanging(false); }, 200);
  };

  useEffect(() => {
    if (lightbox < 0) return;
    const onKey = (e) => {
      if (e.key==='Escape')     close();
      if (e.key==='ArrowRight') step(1);
      if (e.key==='ArrowLeft')  step(-1);
    };
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = prev; };
  }, [lightbox, close, step]);

  return (
    <div className="gallery-page">

      {/* ── Hero ── */}
      <section className="gallery-hero-section">
        <span className="gh-overlay" />
        <span className="gh-glow-a" /><span className="gh-glow-b" />
        <div className="gh-particles" aria-hidden="true">
          {[...Array(5)].map((_,i)=><span key={i} className={`gh-part gh-part--${i+1}`}/>)}
        </div>

        <div className="container gh-inner">
          <motion.div
            className="gh-content"
            initial="hidden"
            animate="show"
            variants={stagger}
          >
            <motion.nav className="gh-breadcrumb" variants={fadeUp}>
              <Link to="/">Home</Link>
              <FaChevronRight className="gh-sep" />
              <span>Gallery</span>
            </motion.nav>
            <motion.p className="gh-eyebrow" variants={fadeUp}>Our Work</motion.p>
            <motion.h1 className="gh-title" variants={fadeUp}>
              Our <span className="gh-title-accent">Gallery</span>
            </motion.h1>
            <motion.p className="gh-subtitle" variants={fadeUp}>
              A look inside our recycling facility — from IT asset dismantling and secure data
              destruction to metal recovery and responsible disposal.
            </motion.p>
            {/* Photo count pills */}
            <motion.div className="gh-pills" variants={fadeUp}>
              {filters.map((f,i) => (
                <span key={i} className="gh-pill">
                  {f.icon} {f.label} <strong>{f.images.length}</strong>
                </span>
              ))}
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* ── Body ── */}
      <section className="gallery-body">
        <span className="gb-decor"><span className="gb-glow-a"/><span className="gb-glow-b"/></span>
        <div className="container gb-inner">

          <motion.header
            className="gallery-head"
            initial={{ opacity:0, y:40 }}
            whileInView={{ opacity:1, y:0 }}
            viewport={{ once:true }}
            transition={{ duration:0.6 }}
          >
            <span className="gallery-eyebrow">Inside KMK Industries</span>
            <h2 className="gallery-title">Our Work in <span className="text-green">Pictures</span></h2>
            <p className="gallery-desc">
              Browse our operations by category, or click any photo to view it full size.
            </p>
          </motion.header>

          {/* Filter tabs */}
          <motion.div
            className="gallery-filter-bar"
            initial={{ opacity:0, y:20 }}
            whileInView={{ opacity:1, y:0 }}
            viewport={{ once:true }}
            transition={{ duration:0.5, delay:0.1 }}
          >
            <div className="gallery-filter" role="tablist" aria-label="Gallery categories">
              {filters.map((f, i) => (
                <button
                  key={f.label}
                  type="button"
                  role="tab"
                  aria-selected={activeTab===i}
                  className={`filter-btn${activeTab===i?' active':''}`}
                  onClick={() => switchTab(i)}
                >
                  <FaImages className="filter-icon" />
                  {f.label}
                  <span className="filter-count">{f.images.length}</span>
                </button>
              ))}
            </div>
          </motion.div>

          {/* Grid */}
          <AnimatePresence mode="wait">
            {!isChanging && (
              <motion.div
                key={activeTab}
                initial={{ opacity:0 }}
                animate={{ opacity:1 }}
                exit={{ opacity:0 }}
                transition={{ duration:0.2 }}
              >
                <GridSection images={images} onOpen={setLightbox} />
              </motion.div>
            )}
          </AnimatePresence>

          <motion.p
            className="gallery-count"
            initial={{ opacity:0 }}
            whileInView={{ opacity:1 }}
            viewport={{ once:true }}
            transition={{ delay:0.3 }}
          >
            Showing <strong>{images.length}</strong> {images.length===1?'photo':'photos'}
          </motion.p>
        </div>
      </section>

      {/* ── Lightbox ── */}
      <AnimatePresence>
        {lightbox >= 0 && (
          <motion.div
            className="lightbox"
            onClick={close}
            role="dialog"
            aria-modal="true"
            aria-label="Image lightbox"
            initial={{ opacity:0 }}
            animate={{ opacity:1 }}
            exit={{ opacity:0 }}
            transition={{ duration:0.22 }}
          >
            {/* Close */}
            <motion.button
              type="button" className="lb-close"
              onClick={close} aria-label="Close"
              initial={{ opacity:0, rotate:-90 }}
              animate={{ opacity:1, rotate:0 }}
              transition={{ delay:0.15 }}
            >
              <FaTimes />
            </motion.button>

            {/* Prev */}
            <button
              type="button" className="lb-nav lb-prev"
              onClick={(e)=>{ e.stopPropagation(); step(-1); }}
              aria-label="Previous image"
            >
              <FaChevronLeft />
            </button>

            {/* Image */}
            <AnimatePresence mode="wait">
              <motion.img
                key={lightbox}
                className="lb-img"
                src={images[lightbox]}
                alt={`KMK Industries gallery ${lightbox+1}`}
                onClick={e=>e.stopPropagation()}
                initial={{ opacity:0, scale:0.94 }}
                animate={{ opacity:1, scale:1 }}
                exit={{ opacity:0, scale:0.94 }}
                transition={{ duration:0.28, ease:'easeOut' }}
              />
            </AnimatePresence>

            {/* Next */}
            <button
              type="button" className="lb-nav lb-next"
              onClick={(e)=>{ e.stopPropagation(); step(1); }}
              aria-label="Next image"
            >
              <FaChevronRight />
            </button>

            {/* Counter */}
            <motion.span
              className="lb-counter"
              initial={{ opacity:0, y:10 }}
              animate={{ opacity:1, y:0 }}
              transition={{ delay:0.2 }}
            >
              {lightbox+1} / {images.length}
            </motion.span>
          </motion.div>
        )}
      </AnimatePresence>

    </div>
  );
};

export default Galary;
